// Added the className prop here to allow external styling
const Avatar = ({ profile, className }) => {
  const customImage = profile?.avatar_url || profile?.bubble_image_url;

  const defaultClasses = "w-12 h-12 rounded-full object-cover";
  const finalClass = className || defaultClasses;

  if (customImage) {
    return (
      <img 
        src={customImage} 
        alt={profile?.name || profile?.display_name || 'User'} 
        className={finalClass} 
        referrerPolicy="no-referrer"
      />
    );
  }

  // deterministic hash from string
  const hashStringToNumber = (str) => {
    if (!str) return 0;

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0; // convert to 32bit int
    }
    return Math.abs(hash);
  };

  // fallback priority: user_id → id → name → 0
  const baseId =
    profile?.user_id ??
    profile?.id ??
    hashStringToNumber(profile?.name);

  const imageIndex = baseId % 5;
  const defaultAvatarPath = `/images/avatars/default-${imageIndex}.png`;

  return (
    <img 
      src={defaultAvatarPath} 
      alt="Default avatar" 
      className={finalClass}
    />
  );
};

export default Avatar;